import React from 'react';
import { checkGlyph, checkPuzzle, revealPuzzle, revealGlyph } from '../arithmeglyphsUtils';
import { ArithmeglyphsStore } from '../ArithmeglyphsStore';
import CustomRevealConfirmationDialog from '../../shared/CustomRevealConfirmationDialog';

const RevealConfirmationDialogCluster = () => {
  const { confirmationDialogs } = ArithmeglyphsStore.useState();

  return (
    <>
      <CustomRevealConfirmationDialog
        store={ArithmeglyphsStore as any}
        onConfirm={checkGlyph}
        onClose={() => {
          ArithmeglyphsStore.update(s => {
            s.confirmationDialogs.checkGlyphIsOpen = false;
          });
        }}
        isOpen={confirmationDialogs.checkGlyphIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArithmeglyphsStore as any}
        onConfirm={checkPuzzle}
        onClose={() => {
          ArithmeglyphsStore.update(s => {
            s.confirmationDialogs.checkPuzzleIsOpen = false;
          });
        }}
        isOpen={confirmationDialogs.checkPuzzleIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArithmeglyphsStore as any}
        onConfirm={revealGlyph}
        onClose={() => {
          ArithmeglyphsStore.update(s => {
            s.confirmationDialogs.revealGlyphIsOpen = false;
          });
        }}
        isOpen={confirmationDialogs.revealGlyphIsOpen}
      />
      <CustomRevealConfirmationDialog
        store={ArithmeglyphsStore as any}
        onConfirm={revealPuzzle}
        onClose={() => {
          ArithmeglyphsStore.update(s => {
            s.confirmationDialogs.revealPuzzleIsOpen = false;
          });
        }}
        isOpen={confirmationDialogs.revealPuzzleIsOpen}
        prompt="Are you sure you want to reveal the full puzzle? This puzzle will count as revealed and be excluded from any solve streak."
      />
    </>
  )
};

export default RevealConfirmationDialogCluster;